import {
  ComponentPublicInstance, Ref,
  ref, watch, onMounted, nextTick,
} from 'vue'

export function getRows(row: number, min: number, max: number): number {
  let nextRow = row
  if (row <= min) {
    nextRow = min
  } else if (row >= max) {
    nextRow = max
  }
  return nextRow
}

type AutoExpandParams = {
  inputRef: Ref<ComponentPublicInstance|null>
  modelValue: Ref<string|undefined>
  paddingHeight: Ref<number>
  initialRows: number
  maxRows: number
  minRows: number
  lineHeight: number
}
type AuotExpandHooks = {
  rowState: Ref<number>
}
export function useAutoExpand({
  modelValue,
  inputRef,
  initialRows,
  minRows,
  maxRows,
  paddingHeight,
  lineHeight,
}: AutoExpandParams) : AuotExpandHooks {
  const rowState = ref(getRows(initialRows, minRows, maxRows))

  const BASE_SCROLL_HEIGHT = 32

  function checkAndExpand(shrink = false) {
    const elCmp = inputRef.value
    if (elCmp) {
      let { scrollHeight } = elCmp.$el
      if (shrink) {
        scrollHeight = 0
      }
      const diffRows = Math.ceil(
        (scrollHeight - paddingHeight.value - 10 - BASE_SCROLL_HEIGHT)
            / lineHeight,
      )
      const nextRow = getRows(
        diffRows + initialRows,
        minRows,
        maxRows,
      )
      if (rowState.value !== nextRow) {
        rowState.value = nextRow
      }
      if (shrink) {
        nextTick(() => {
          checkAndExpand()
        })
      }
    }
  }
  watch(modelValue, (newV, oldV) => {
    if (typeof newV === 'string' && typeof oldV === 'string') {
      if (newV.length < oldV.length) {
        checkAndExpand(true)
        return
      }
    }
    checkAndExpand()
  }, {
    flush: 'post',
  })

  onMounted(() => {
    nextTick(() => {
      if (inputRef.value) {
        requestAnimationFrame(() => checkAndExpand())
      }
    })
  })
  return {
    rowState,
  }
}
